import type { InitOptions } from 'i18next';

export const fallbackLng = 'en-US';
export const locales: string[] = [fallbackLng, 'es', 'es-US'] as const;
export type LocaleTypes = (typeof locales)[number];
export const defaultNS = 'common';

export const i18n = {
  defaultLocale: 'en-US',
  locales: ['en-US', 'es-US', 'es'],
} as const;

export type Locale = (typeof i18n)['locales'][number];

export function getOptions(lang = fallbackLng, ns = defaultNS): InitOptions {
  return {
    // debug: true, // Set to true to see console logs
    supportedLngs: locales,
    fallbackLng,
    lng: lang,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
  };
}
